/**
 * Password Reset Redirect Component
 * Handles password reset links that come from the backend
 * Redirects to the frontend reset password page with proper parameters
 */

import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useNotifications } from '../../components/common/NotificationSystem';
import ProfessionalLoader from "../../components/common/ProfessionalLoader";
import { authService } from '../../services/authService';
import './Auth.css';

const PasswordResetRedirect = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { showError } = useNotifications();

  useEffect(() => {
    const handleRedirect = async () => {
      try {
        const uid = searchParams.get('uid');
        const token = searchParams.get('token');

        if (!uid || !token) {
          showError('Invalid reset link. Missing required parameters.', 'Invalid Link');
          navigate('/forgot-password');
          return;
        }

        // Validate the token using the authService
        try {
          const validationResponse = await authService.getPasswordResetInfo(uid, token);
          
          if (validationResponse.success && validationResponse.data.valid) {
            // Token is valid, redirect to the frontend reset page
            navigate(`/reset-password?uid=${uid}&token=${token}`);
          } else {
            // Token is invalid or expired
            showError(validationResponse.data?.error || 'Reset link is invalid or has expired', 'Invalid Link');
            navigate('/forgot-password');
          }
        } catch (error) {
          showError('Failed to validate reset link. Please try again.', 'Validation Error');
          navigate('/forgot-password');
        }

      } catch (error) {
        showError('An error occurred while processing the reset link.', 'Error');
        navigate('/forgot-password');
      } finally {
        // setIsValidating(false);
      }
    };

    handleRedirect();
  }, [searchParams, navigate, showError]);

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <ProfessionalLoader size="large" variant="default" />
        </div>
      </div>
    </div>
  );
};

export default PasswordResetRedirect;
